import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import React from 'react';
import { ViewStyles } from '@bubble-ui/primitive-view';
var StepperWrapper = _ref => {
  var {
    children,
    UNSAFE_props
  } = _ref;
  return /*#__PURE__*/React.createElement("ul", _extends({}, UNSAFE_props, {
    style: _objectSpread(_objectSpread({}, ViewStyles), {}, {
      margin: 0,
      paddingLeft: 0,
      listStyle: 'none'
    })
  }), children);
};
StepperWrapper.displayName = 'StepperWrapper';
export { StepperWrapper };
//# sourceMappingURL=index.js.map